
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BankTransferForm } from "./BankTransferForm";

interface BankDetails {
  beneficiaryName: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  otherDetails: string;
}

interface PayoutSettingsProps {
  earnings: number;
  lastPayoutDate: string | null;
  payoutEmail: string;
  setPayoutEmail: (email: string) => void;
  payoutMethod: string;
  setPayoutMethod: (method: string) => void;
  bankDetails: BankDetails;
  setBankDetails: (details: BankDetails) => void;
  onSave: () => void;
}

export const PayoutSettings = ({
  lastPayoutDate,
  payoutEmail,
  setPayoutEmail,
  payoutMethod,
  setPayoutMethod,
  bankDetails,
  setBankDetails,
  onSave,
}: PayoutSettingsProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">Payout Settings</h3>
        <p className="text-sm text-gray-500">
          Manage your payout preferences. Minimum payout threshold is $25.
          Payments are processed automatically on the 15th of each month.
        </p>
      </div>

      <div className="space-y-4">
        {lastPayoutDate && (
          <p className="text-sm text-gray-500">
            Last payout: {new Date(lastPayoutDate).toLocaleDateString()}
          </p>
        )}

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Payout Email
          </label>
          <Input
            type="email"
            value={payoutEmail}
            onChange={(e) => setPayoutEmail(e.target.value)}
            placeholder="Enter your payout email"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Payout Method
          </label>
          <Select value={payoutMethod} onValueChange={setPayoutMethod}>
            <SelectTrigger>
              <SelectValue placeholder="Select payout method" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="paypal">PayPal</SelectItem>
              <SelectItem value="bank_transfer">Bank Transfer</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {payoutMethod === 'bank_transfer' && (
          <BankTransferForm
            bankDetails={bankDetails}
            setBankDetails={setBankDetails}
          />
        )}

        <Button onClick={onSave}>
          Save Payout Settings
        </Button>
      </div>
    </div>
  );
};
